
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.085 2.622a1.855 1.855 0 011.629 1.235l1.116 2.234v.005a.821.821 0 00.465.34l2.011.331a1.839 1.839 0 011.631 1.172 1.849 1.849 0 01-.641 1.914l-1.574 1.579a.79.79 0 00-.166.593l.452 1.949a2.161 2.161 0 01-.245 1.915 1.358 1.358 0 01-1.091.5 2.724 2.724 0 01-1.367-.443l-1.892-1.123a.771.771 0 00-.636 0l-1.901 1.125a2.74 2.74 0 01-1.366.439 1.359 1.359 0 01-1.092-.5 2.157 2.157 0 01-.244-1.915l.448-1.946a.808.808 0 00-.171-.594L4.884 9.856a1.842 1.842 0 01-.645-1.9 1.846 1.846 0 011.629-1.184l2.019-.332a.793.793 0 00.457-.339v-.005l1.122-2.235a1.832 1.832 0 011.619-1.239zm1.682 4L11.652 4.39c-.215-.428-.44-.581-.567-.581s-.345.151-.553.576L9.414 6.62a1.967 1.967 0 01-1.331.988l-2.016.332c-.372.064-.645.21-.7.373-.041.129.03.381.353.7l1.579 1.579.006.006a1.982 1.982 0 01.477 1.7l-.451 1.946a1.229 1.229 0 00.017.9c.013.016.043.054.163.054a1.578 1.578 0 00.761-.273l1.889-1.123a1.933 1.933 0 011.86 0l1.891 1.123a1.567 1.567 0 00.76.276c.119 0 .148-.038.161-.054a1.232 1.232 0 00.018-.908l-.452-1.945a1.965 1.965 0 01.483-1.7l1.575-1.575c.324-.327.393-.587.353-.711-.052-.161-.325-.3-.7-.366l-2.013-.334h-.012a1.974 1.974 0 01-1.318-.988z","fill":"#697485"}}),_c('path',{attrs:{"data-name":"Vector","d":"M6.334 4.553h-4.75a.594.594 0 01-.594-.594.594.594 0 01.594-.594h4.75a.594.594 0 01.594.594.594.594 0 01-.594.594zM3.959 15.636H1.584a.594.594 0 01-.594-.594.594.594 0 01.594-.594h2.375a.594.594 0 01.594.594.594.594 0 01-.594.594zM2.375 10.094h-.791A.594.594 0 01.99 9.5a.594.594 0 01.594-.594h.791a.594.594 0 01.594.594.594.594 0 01-.594.594z","fill":"#697485","opacity":".4"}})])
          )
        }
      }
    